'use client';

import { useState } from 'react';

import { ClickableDiv } from '@wwe-portal/ui/components/button';
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipPortal,
  TooltipTrigger,
} from '@wwe-portal/ui/components/tooltip';

const TooltipWrapper = ({
  content,
  children,
  className,
}: {
  content: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}) => {
  const [openTooltip, setOpenTooltip] = useState(false);
  return (
    <Tooltip onOpenChange={setOpenTooltip} open={openTooltip}>
      <TooltipTrigger asChild>
        <ClickableDiv
          onClick={(e) => {
            e.stopPropagation();
            setOpenTooltip((currentOpen) => !currentOpen);
          }}
          className={className}
        >
          {children}
        </ClickableDiv>
      </TooltipTrigger>
      <TooltipPortal>
        {content && (
          <TooltipContent>
            {content}
            <TooltipArrow />
          </TooltipContent>
        )}
      </TooltipPortal>
    </Tooltip>
  );
};

export default TooltipWrapper;
